import { LinearProgress, Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import { VaccinationActForm } from "../../components/vaccination/VaccinationActForm";
import { useHealthRecord } from "../../hooks/useHealthRecord";
import { useHealthRecordVaccination } from "../../hooks/useHealthRecordVaccination";
import { theme } from "../../layout/Theme";

export const EditVaccinationAct = ({ isEmbedded = false }: { isEmbedded?: boolean }) => {
  const { id: healthRecordId, vaccinationActId } = useParams() as {
    id: string;
    vaccinationActId: string;
  };
  const { healthRecord, isLoading: healthRecordIsLoading } = useHealthRecord(healthRecordId);
  const { vaccinationAct, isLoading } = useHealthRecordVaccination(healthRecordId, vaccinationActId);

  return isLoading || (healthRecordIsLoading && !healthRecord) ? (
    <LinearProgress variant="query" />
  ) : healthRecord && vaccinationAct ? (
    <Paper
      sx={{
        overflow: "hidden",
        border: isEmbedded ? "none" : `solid 1px ${theme.palette.neutral[200]}`,
        px: 4,
        py: 2,
      }}
      elevation={0}
    >
      <VaccinationActForm healthRecord={healthRecord} vaccinationAct={vaccinationAct} />
    </Paper>
  ) : null;
};
